var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('PageHeader',{attrs:{"breadcrumbLinks":_vm.breadcrumbLinks,"title":'Whatsapp',"subtitle":'Detalhes'}}),_c('div',{staticClass:"page-content container-fluid"},[_c('properties-card')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }